import React, { createContext, useContext, useEffect, useState } from "react";
import { publicApi, CUSTOMER_TOKEN_KEY } from "@/lib/api";

const CustomerAuthContext = createContext(null);

export function CustomerAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);
  // Global Sign In modal state (opened from header / checkout).
  const [authModalOpen, setAuthModalOpen] = useState(false);

  useEffect(() => {
    // If we're returning from the Emergent OAuth callback, skip the /me check —
    // GoogleAuthCallback will exchange the session_id and establish the session.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    const token = localStorage.getItem(CUSTOMER_TOKEN_KEY);
    if (!token) { setLoading(false); return; }
    publicApi.get("/auth/me")
      .then((r) => setCustomer(r.data))
      .catch(() => localStorage.removeItem(CUSTOMER_TOKEN_KEY))
      .finally(() => setLoading(false));
  }, []);

  const setSession = (token, c) => {
    localStorage.setItem(CUSTOMER_TOKEN_KEY, token);
    setCustomer(c);
  };
  const login = async (email, password) => {
    const r = await publicApi.post("/auth/login", { email, password });
    setSession(r.data.token, r.data.customer);
    return r.data.customer;
  };
  const register = async (payload) => {
    const r = await publicApi.post("/auth/register", payload);
    setSession(r.data.token, r.data.customer);
    return r.data.customer;
  };
  // Exchange an Emergent OAuth session_id for an LCH customer JWT.
  const loginWithGoogleSession = async (sessionId) => {
    const r = await publicApi.post("/auth/google/session", { session_id: sessionId });
    setSession(r.data.token, r.data.customer);
    return r.data.customer;
  };
  const logout = () => { localStorage.removeItem(CUSTOMER_TOKEN_KEY); setCustomer(null); };
  const refresh = async () => {
    try { const r = await publicApi.get("/auth/me"); setCustomer(r.data); } catch { /* noop */ }
  };
  const openAuthModal = () => setAuthModalOpen(true);

  return (
    <CustomerAuthContext.Provider value={{
      customer, loading, login, register, loginWithGoogleSession, logout, setSession, refresh,
      authModalOpen, setAuthModalOpen, openAuthModal,
    }}>
      {children}
    </CustomerAuthContext.Provider>
  );
}

export const useCustomerAuth = () => useContext(CustomerAuthContext);
